import React from "react"
import PropTypes from "prop-types"
import UnifiedDatePicker from "../../../../../components/compounds/UnifiedDatePicker.compound"
import ResetButton from "../../../../generalReport/controllers/components/ResetButton"
import InputSearch from "../../../../../components/molecules/InputSearch.molecule"

const HistoricalTasksControls = ({
  dateRange,
  setDateRange,
  period,
  setPeriod,
  onReset,
  globalFilter,
  setGlobalFilter,
  isLoading,
}) => {
  return (
    <div
      className={`historical-pending-tasks-controls flex flex-1 justify-content-between align-items-center gap-3 ${globalFilter === "" ? "mb-4" : "mb-3"}`}
    >
      <div className="dropdown-controls flex">
        <InputSearch
          value={globalFilter}
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder="Buscar"
          className="historical-pending-tasks-search"
        />
        <UnifiedDatePicker
          dateRange={dateRange}
          setDateRange={setDateRange}
          period={period}
          setPeriod={setPeriod}
          disabledChevrons={isLoading}
        />
      </div>
      <ResetButton onClick={onReset} />
    </div>
  )
}

export default HistoricalTasksControls

HistoricalTasksControls.propTypes = {
  dateRange: PropTypes.array,
  setDateRange: PropTypes.func,
  period: PropTypes.string,
  setPeriod: PropTypes.func,
  onReset: PropTypes.func,
  globalFilter: PropTypes.string,
  setGlobalFilter: PropTypes.func,
  isLoading: PropTypes.bool,
}
